import QuestionCreator from '../questionCreator';
import TaskDetails from '../../../components/shared/TaskDetails';

import { IQuestionComponentProps } from '../types';

import { HISTORY_TYPE } from '../../../constants';

import imgBuilding from '/images/buildings.svg';

const DailyLivingComponent: React.FC<IQuestionComponentProps> = ({
  isQuestionnaireComplete,
  questionnaires,
  toggleQuestionnaireCompletion,
  navigateToTasks,
}) => {
  if (isQuestionnaireComplete) {
    return (
      <TaskDetails
        title="Daily living"
        description="Provide details about your daily living activities to help us tailor our support."
        buttonText="Complete questionnaire"
        imgSrc={imgBuilding}
        imgAlt="buildings"
        imgWidth="268px"
        handleClick={toggleQuestionnaireCompletion}
        handleClose={navigateToTasks}
      />
    );
  }

  if (questionnaires)
    return (
      <QuestionCreator
        questionnaires={questionnaires}
        historyType={HISTORY_TYPE.DAILY_LIVING}
      />
    );

  return null;
};

export default DailyLivingComponent;
